<div class="grid-x max-width">
  <div class="cell small-5">
    <span class="padding-right">
      <button class="arrow" (click)="previous()" [disabled]="currentPage?.pageNumber === 1">&lt; Previous</button>
    </span>
    Page {{currentPage.pageNumber}} @if (totalPages != null) {
    of {{totalPages}}
  }
  <span class="padding-left">
    <button class="arrow" (click)="next()" [disabled]="atSearchLimit || currentPage?.pageNumber === totalPages">Next &gt;</button>
  </span>
</div>
<div class="cell small-7 padding-left text-align-left">
  <select (change)="resultsChanged()" [(ngModel)]="currentPage.resultsPerPage">
    @for (opt of resultOptions; track opt) {
      <option [ngValue]="opt">{{opt}}</option>
    }
  </select>
  Results Per Page
</div>
</div>